import apiService from './apiService';

export const getRoles = async () => {
  try {
    const response = await apiService.get(`user-types`);
    return response.data.data;
  } catch (error) {
    console.error('Error fetching user-types:', error);
    throw error;
  }
};
